import { Directive, inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Stammdaten } from '@ebeihilfe/core';
import { LegacyFeldTyp } from '@ebeihilfe/einreichung-shared/enums';
import { LegacyAntragsMetadata } from '@ebeihilfe/einreichung-shared/model';
import { BaseDynamicFormElement } from '@ebeihilfe/forms';

import { AntragsMetadataHelper, KURZANTRAG_CONFIG } from '../types';

@Directive()
export abstract class KurzantragBase implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fields: BaseDynamicFormElement<any>[] = [];
  public form = new FormGroup({});
  public model: Record<string, unknown> = {};
  public userData?: Stammdaten;

  protected readonly kurzantragConfig = inject(KURZANTRAG_CONFIG);

  public ngOnInit(): void {
    this.fields = this.kurzantragConfig.formlyConfig;
  }

  public submit(): void {
    if (!this.userData) {
      throw new Error('stammdaten object missing');
    }

    const antragsMetadata: LegacyAntragsMetadata[] = [];
    antragsMetadata.push(...KurzantragBase.convertStammdaten(this.userData));
    antragsMetadata.push(...this.convertMetadata(this.kurzantragConfig.meta));
    this.closeUp(antragsMetadata);
  }

  protected abstract closeUp(antragsMetadata: LegacyAntragsMetadata[]): void;

  private convertMetadata(metaData: AntragsMetadataHelper[]): LegacyAntragsMetadata[] {
    return metaData.map((datum) => ({
      keyDom: datum.keyDom,
      keyInternal: datum.keyInternal,
      type: datum.type,
      value:
        datum.type === LegacyFeldTyp.TEXT
          ? datum.valueFromForm(this.model)?.toString()
          : datum.valueFromForm(this.model),
    }));
  }

  private static convertStammdaten(stammdaten: Stammdaten): LegacyAntragsMetadata[] {
    return [
      {
        keyDom: 'nachname',
        keyInternal: 'Nachname',
        type: LegacyFeldTyp.TEXT,
        value: stammdaten.nachname,
      },
      {
        keyDom: 'vorname',
        keyInternal: 'Vorname',
        type: LegacyFeldTyp.TEXT,
        value: stammdaten.vorname,
      },
      {
        keyDom: 'gebDat',
        keyInternal: 'Geburtsdatum',
        type: LegacyFeldTyp.TEXT,
        value: stammdaten.gebdat,
      },
      {
        keyDom: 'personalnummer',
        keyInternal: 'Personalnummer',
        type: LegacyFeldTyp.TEXT,
        value: stammdaten.personalnummer,
      },
      {
        keyDom: 'emailadresse',
        keyInternal: 'EMailAdresse',
        type: LegacyFeldTyp.TEXT,
        value: stammdaten.email,
      },
    ];
  }
}
